'use client'

import React, { FunctionComponent } from 'react'
import styles from './HeadWithSubhead.module.css'
import { formatRelativeUrl } from '@/utils/urls.utils'

type Props = {
  head: string
  subhead?: string
  link?: string
}

const HeadWithSubhead: FunctionComponent<Props> = ({ head, subhead, link }: Props) => {
  let titleContent = <h2 className={styles.Head} data-testid="title-head">{head}</h2>
  if (link) {
    titleContent = (
      <a href={formatRelativeUrl(link)} className={styles.Link}>
        {titleContent}
      </a>
    )
  }
  return (
    <>
      {titleContent}
      {subhead && (
        <h3 className={styles.SubHead} data-testid="title-subhead">
          {subhead}
        </h3>
      )}
    </>
  )
}

export default HeadWithSubhead
